// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3aV7R","icon":"SortAdornment_icon__SWNJY","up":"SortAdornment_up__2aR2R","down":"SortAdornment_down__18nD7","active":"SortAdornment_active__2feDk"};